import { Search, Bell, LogOut, Menu } from "lucide-react";
import { useAuthStore } from "@/lib/auth.js";

export function Topbar({ menuAbierto = false, onMenu }: Readonly<{ menuAbierto?: boolean; onMenu?: () => void }>) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const initials = user?.fullName
    .split(" ")
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("") ?? "??";
  return (
    <header className="h-14 bg-white border-b border-slate-200 px-3 md:px-6 flex items-center gap-2 md:gap-4 dark:bg-slate-900 dark:border-slate-800">
      <button
        type="button"
        className="btn-ghost p-2 md:hidden"
        aria-label="Abrir el menú"
        aria-controls="menu-principal"
        aria-expanded={menuAbierto}
        onClick={onMenu}
      >
        <Menu size={18} aria-hidden="true" />
      </button>
      <div className="flex-1 max-w-xl relative hidden sm:block">
        <Search
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
        />
        <input
          className="input pl-9 h-9"
          placeholder="Buscar — ⌘K"
          aria-label="Buscador global"
        />
      </div>
      <span className="flex-1 sm:hidden" />
      <span className="badge-info mono">PROD</span>
      <button className="btn-ghost p-2" aria-label="Notificaciones">
        <Bell size={16} />
      </button>
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-brand-500 text-white grid place-items-center text-xs font-semibold">
          {initials}
        </div>
        <div className="text-sm hidden sm:block">
          <div className="font-medium leading-tight">{user?.fullName}</div>
          <div className="text-xs text-slate-500 leading-tight">
            {user?.roles[0] ?? "—"}
          </div>
        </div>
        <button className="btn-ghost p-2" onClick={logout} aria-label="Salir">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}
